import { useTranslation } from 'react-i18next';
import whiteTelegramImg from '@/assets/images/whiteTelegram.svg';
import { brandLinks } from '@/shared/config/brand';

const FixiedTgBtn = () => {
  const { t } = useTranslation();

  return (
      <a
        href={brandLinks.telegramOperatorWithText}
        target='_blank'
        rel='noopener noreferrer'
        className='fixied-tg-btn'
      >
        <img src={whiteTelegramImg} alt="Telegram" width={15} height='auto'/>
        {t('companyInfo.firstBlockBtn')}
      </a>
  );
};

export default FixiedTgBtn;
